import { createSelector } from 'reselect';
import { showSalesPagePercentageOff } from 'selectors/testTarget/offers/showPercentageOff/showPercentageOff';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showPercentageOffSelector = createSelector(isTestTargetReadySelector, showSalesPagePercentageOff, (testReady, show) => testReady && show);

export { showPercentageOffSelector };
